import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useState } from "react";

type Props = {
  open: boolean;
  title?: string;
  description?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (totpCode: string) => void | Promise<void>;
};

export function StepUpTotpDialog({
  open,
  title = "ຢືນຢັນດ້ວຍ 2FA",
  description = "ປ້ອນລະຫັດ 6 ຫຼັກຈາກແອບ Authenticator ກ່ອນດຳເນີນການ.",
  loading = false,
  onClose,
  onConfirm,
}: Props) {
  const [code, setCode] = useState("");

  const handleClose = () => {
    setCode("");
    onClose();
  };

  const handleConfirm = async () => {
    const trimmed = code.replace(/\D/g, "");
    if (trimmed.length !== 6) return;
    await onConfirm(trimmed);
    setCode("");
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !next && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Input
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="123456"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          onKeyDown={(e) => {
            if (e.key === "Enter") void handleConfirm();
          }}
        />
        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            ຍົກເລີກ
          </Button>
          <Button
            onClick={() => void handleConfirm()}
            disabled={loading || code.replace(/\D/g, "").length !== 6}
          >
            {loading ? "ກຳລັງຢືນຢັນ..." : "ຢືນຢັນ"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
